<template>
    <div class="Aside-styles-betslip-container">
      <div class="Aside-styles-aside-tabs">
        <button @click="changePage(1)"
                testid="Button_tab_button_betslip-selected_odds-tab" id="tab-button-betslip-selected_odds-tab"
                :class="(page === 1) ? 'TabButton-styles-tab-button-active' : ''"
                class="Button-styles-button TabButton-styles-tab-button TabButton-styles-tab-button-full-width Aside-styles-aside-tab">
          <div class="">
            <div class="TabNavTitle-styles-tab-nav-title Aside-styles-tab-title TabNavTitle-styles-with-subtitle">
              <div class="notranslate">{{ bets.length }}</div>
              <div class="">{{ t.coupon }}</div>
            </div>
          </div>
        </button>
        <button testid="Button_tab_button_betslip-open-bets-tab"
                @click="changePage(2)"
                :class="(page === 2) ? 'TabButton-styles-tab-button-active' : ''"
                id="tab-button-betslip-open-bets-tab"
                class="Button-styles-button TabButton-styles-tab-button TabButton-styles-tab-button-full-width Aside-styles-aside-tab">
                <div class="">
                  <div class="TabNavTitle-styles-tab-nav-title Aside-styles-tab-title TabNavTitle-styles-with-subtitle">
                    <div class="notranslate">{{ session.waiting_bets || 0 }}</div>
                    <div class="">{{ t.betting.title.open_bets }}</div>
                  </div>
                </div>
        </button>
      </div>
        <template v-if="betCreated">
          <BetSlipSuccess />
        </template>

        <template v-if="!betCreated && page === 1">

            <div class="betContent">
              <div class="Betslip-styles-betslip" v-if="bets.length === 0">
                <div data-testid="emptyBetslip" class="EmptyDesktopBetslip-styles-empty-betslip">
                  <img src="/static/assets/img/empty-betslip.svg" alt="empty betslip" width="55" height="64">
                  <p>
                    <span>{{ t.betSlip.no_bets }}</span>
                  </p>
                </div>
              </div>
                <div v-if="bets.length > 0">
                  <header class="BetslipHeader-styles-betslip-header" v-show="bets.length > 0">
                    <div class="BetslipHeader-styles-title-cell">
                      <div class="Tooltip-styles-tooltip Tooltip-styles-placement-bottom" id="system-type-select">
                        <select v-model="currentType" class="Tooltip-styles-container Tooltip-styles-down Tooltip-styles-dropdown BetslipHeader-styles-dropdown-container">
                          <option v-for="type in couponTypes" :value="type.id">{{ t[type.type] }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="BetslipHeader-styles-buttons-cell">
                      <div class="Tooltip-styles-tooltip Tooltip-styles-placement-top-center HeaderClearButton-styles-tooltip">
                        <div class="Tooltip-styles-container">
                          <button id="betslip-header-button-delete" v-on:click="clear" v-tooltip="t.betSlip.clear" class="BetslipHeaderButton-styles-icon-button HeaderClearButton-styles-header-icon">
                            <div class="BetslipHeaderButton-styles-icon-cell">
                              <div class="BetslipHeaderButton-styles-icon BetslipHeaderButton-styles-delete HeaderClearButton-styles-icon"></div>
                            </div>
                            <div class="BetslipHeaderButton-styles-title-cell">
                              <div class="BetslipHeaderButton-styles-title"></div>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </header>

                  <div class="possibleSystems" v-if="activeType == 3 && systemBets.length > 0">
                    <ul>
                      <li class="head">{{ t.betSlip.possible_systems }}</li>
                      <li class="BetslipEvent-styles-content" v-for=" (system, s) in possibleCombinations" v-if="s > 1 && possibleCombinations[s].bets > 1">
                        <a href="javascript:void(0);" v-on:click="selectSystem(possibleCombinations[s], s)">
                          <i class="fa fa-check-square-o" v-if="isSelectedSystem(s)"></i>
                          <i class="fa fa-square-o" v-else></i>
                          <span v-if="bankers.length > 0">{{ bankers.length }} B +</span> {{ s }} / 
                          <span v-if="uniqueEventIds.length > 0">{{ uniqueEventIds.length }} Sytem</span>
                          <span v-else>{{ systemBets.length }} Sytem</span>
                          <span class="betCount">({{ t.betSlip.bet_count }}: {{ possibleCombinations[s].bets }})</span>
                        </a>
                        <!--<span class="pull-right"><i class="fa fa-info-circle"></i></span>
                        <span class="pull-right mr-3"><i class="fa fa-eye"></i></span>-->
                      </li>
                    </ul>
                  </div>

                  <div class="event-area">
                      <section data-testid="betslip-selection" v-for="(bet,index) in bets">
                        <div id="betslip-event-510161710-list-item" class="BetslipEvent-styles-betslip-event">
                          <div id="betslip-event-odd-78777553510" class="BetslipEvent-styles-content">
                            <div class="BetslipEvent-styles-info-col" :to="{name: 'SportsbookEvent', params: {event: bet.match.matchId}}">
                              <div class="BetslipEvent-styles-market-picks">
                                <span class="BetslipEvent-styles-pre-postfix">
                                  <span class="isBanker pull-left" v-if="activeType == 3 && uniqueEventIds.length == 0" :class="(bet.banker) ? 'active' : ''" v-on:click="setBanker(bet)">
                                    B
                                  </span>
                                  <span>{{ bet.name }}:</span>
                                </span>
                                <span>{{ getOutcomeSelection(bet.outCome, bet.match) }}</span>
                              </div>
                              <router-link :to="{name: 'SportsbookEvent', params: {event: bet.match.matchId}}">
                              <span class="BetslipEvent-styles-title">
                                {{ bet.match.competitor.oneName | slimiter(18) }} - {{ bet.match.competitor.twoName | slimiter(18) }}
                              </span>
                              <span class="BetslipEvent-styles-title" v-if="bet.match.onLive && bet.active"  :class="(bet.match.onLive) ? 'live-odd-value' : ''">
                                {{ t['event_periods'][bet.match.resultName] || bet.match.resultName }} {{ periodTimer(bet.match) }}
                                <strong>({{ bet.match.data.score.home }}:{{ bet.match.data.score.away }})</strong>
                              </span>
                              <span>
                                <span class="BetslipEvent-styles-title" style="color: #c8102e;display: none">
                                  {{ t.max_stake }}: {{ bet.maxStake | toMoney(session.currency) }}
                                </span>
                              </span>
                              </router-link>
                              <div class="bet-error" v-if="isBetAvailable(bet.oddId)"">
                                  <i class="iconx icon-lock"></i>
                                  {{ betErrors[bet.oddId].msg }}
                              </div>
                            </div>
                            <div class="BetslipEvent-styles-odds-col">
                              <span class="BetslipEvent-styles-icon">
                                <strong v-show="bet.active"">{{ bet.odd }}</strong>
                                <i v-show="!bet.active" class="iconx icon-lock"></i>
                              </span>
                              <img src="/static/assets/img/close.svg" v-tooltip="t.betSlip.remove_this_bet" v-on:click="removeBet(bet)" class="BetslipEvent-styles-delete-button">
                            </div>
                          </div>
                        </div>
                      </section>

                    </div>
                  <div class="">
                    <div class="SystemTypeText-styles-total-odds">
                      <span class="">{{ t.betSlip.bet_count }}</span>
                      <span class="SystemTypeText-styles-total-odds-count">{{ bets.length }}</span>
                    </div>
                  </div>
                  <div class="">
                    <div class="SystemTypeText-styles-total-odds">
                      <select v-model="confirmationType" class="form-control">
                        <option :value="a.id" v-for="a in confirmationTypes">{{ t.betSlip[a.name] }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="BetslipStake-styles-betslip-stake">
                    <div class="BetslipStake-styles-col">
                      <div id="betslip-stake-per-way-input-group" class="BetslipStake-styles-input-group">
                        <div class="BetslipStakeInput-styles-betslip-stake-input">
                          <input id="betslip-stake-per-way-input" name="stake-per-way" class="BetslipStakeInput-styles-input" autocomplete="off" type="text" v-model="amount">{{ session.currency.symbol }}
                        </div>
                        <div class="BetslipStake-styles-info-text">{{ t.stake }}</div>
                      </div>
                    </div>
                    <div class="BetslipStake-styles-col">
                      <div id="betslip-possible_win-info-group" class="BetslipStake-styles-possible-win">
                        <span v-if="activeType === 1 || activeType === 3">{{ Number(totalBonus) | toMoney(session.currency)}}</span>
                        <span v-if="activeType === 2">{{ Number(odds * amount) | toMoney(session.currency)}}</span>
                        <div class="BetslipStake-styles-win-text">{{ t.betting.title.possible_earnings }}</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="this.RecommendedCurrencies.includes(session.currency.iso_code)" class="BetSlipRecommendations-styles-wrapper BetSlipRecommendations-styles-desktop" testid="bet-slip-recommendations">
                    <div class="" @click="setCustomAmount(20)">{{ session.currency.symbol }}20</div>
                    <div class="" @click="setCustomAmount(50)">{{ session.currency.symbol }}50</div>
                    <div class="" @click="setCustomAmount(100)">{{ session.currency.symbol }}100</div>
                    <div class="" @click="setCustomAmount(200)">{{ session.currency.symbol }}200</div>
                  </div>
                  <div class="BetslipStake-styles-reactions">
                    <button id="betslip-place_bet-button" v-if="activeType === 1 || activeType === 3" @click="betPlace()" class="Button-styles-button Button-styles-primary BetslipStake-styles-login-button">
                      <div class="">{{ Number(totalBonus) | toMoney(session.currency)}} {{ t.place_bet }}</div>
                    </button>
                    <button id="betslip-place_bet-button" v-if="activeType === 2" @click="betPlace()" class="Button-styles-button Button-styles-primary BetslipStake-styles-login-button">
                      <div class="">{{ Number(odds * amount) | toMoney(session.currency)}} {{ t.place_bet }}</div>
                    </button>
                  </div>
                    <div class="BetslipStake-styles-reactions" v-tooltip="t.betSlip.max_bet_info" @click="betPlace(maxStake)" v-show="maxStake > 0 && agreement">
                      <button id="betslip-place_bet-button" class="Button-styles-button Button-styles-danger BetslipStake-styles-max-stake-button">
                        <div class=""> Max. {{ maxStake | toMoney(session.currency) }}</div>
                      </button>
                    </div>

                    <div class="mx-2 error-content alert alert-danger text-left px-2" v-if="errors">
                        <li v-for="(error, key) in errors" v-if="error.msg">
                            <i class="icon-close"></i> {{ error.msg }}
                        </li>
                    </div>
                </div>
            </div>
        </template>
        <openBets v-if="page === 2" />
    </div>
</template>

<script>
    import betSlip from '@/mixins/betSlip'
    import openBets from "../widget/openBets";
    import BetSlipSuccess from "./BetSlipSuccess";

    export default {
        name: 'BetSlip',
        mixins: [betSlip],
        components: {openBets, BetSlipSuccess},
        data() {
            return {
                page: 1,
                agreement: true,
                betCreated: false,
                session: window.session,
                slipMode: 1,
                bets: [],
                currentType: 1,
                systemBets: [],
                selectedSystem: [],
                systemCombinations: [],
                systemCoupons: [],
                possibleCombinations: [],
                bankers: [],
                amount: 15,
                RecommendedCurrencies: ['EUR', 'TRY', 'USD'],
                betAmountList: [
                    {
                        id: 0,
                        price: 15,
                    },
                    {
                        id: 1,
                        price: 30,
                    },
                    {
                        id: 2,
                        price: 70,
                    },
                    {
                        id: 3,
                        price: 150,
                    }
                ],
                totalBets: 0,
                totalBonus: 0,
                odds: 1,
                t: this.$root.t,
                activeType: 1,
                betErrors: [],
                errors: null,
                processStart: 0

            }
        },
        watch: {
            'amount'(o, n) {
                this.computeOdds();
            },
            'currentType' (o, n) {
              this.changeCouponType(o)
            },
            '$store.state.betslip' (m) {
              this.$set(this, 'bets', m)
            },
            '$store.state.addBet' ($event) {
              this.addBet($event.bet, $event.market, $event.match);
            },
        },
        beforeDestroy() {
            clearInterval(window.$CheckBetInval);
            this.$bus.$off('betAdd');
            this.$bus.$off('addBet');
            this.$bus.$off('betError');
            this.$bus.$off('betCreated');
            this.$bus.$off('sessionUpdated');
            this.$bus.$off('betCreating');
        },
        mounted() {

            //setTimeout(this.syncSelectionClass(), 5000);
            //clearInterval(window.$CheckBetInval);
            //window.$CheckBetInval =  setInterval(this.syncSelectionClass(), 5000);

            this.fetchBets();
            //this.checkBetCurrentValue();

            this.$bus.$on('addBet', ($event) => {

               // this.fetchBets();

            });

            this.$bus.$on('betError', (payload) => {
                this.processStart = 0;
            });

            this.$bus.$on('betCreated', (payload) => {
                this.processStart = 0;
                this.betCreated = true;
                this.$root.loader = false

                setTimeout(() => {
                    this.betCreated = false;
                }, 5000);

                this.$bus.$emit('sessionUpdated', true);
            });

            this.$bus.$on('betCreating', (payload) => {
                clearInterval(window.$CheckBetInval);
                this.processStart = 1;
            });

            this.$bus.$on('betAdd', ($event) => {
                //this.addBet($event.bet, $event.market, $event.match);
            });

            /*window.wss.subscribe("stream/odd", function (uri, payload) {

                var odds = self.bets;

                for (var o in odds) {
                    var odd = odds[o];
                    odd.change = (odd.change) ? odd.change : null;

                    if (payload.id == odd.oddId) {
                        console.log(payload);
                        odd.change = (payload.o > payload.n) ? 'down' : 'up';

                        odd.odd = parseFloat(payload.n).toFixed(2);

                        console.log(payload);
                    }
                }

                self.updateBets(odds);

                setTimeout(self.resetOdd(), 6000);
            })*/
        },
        methods: {
            changePage(p) {
                this.page = p;
            },
            closeModal() {
                document.body.style.overflowY = "auto"
            },
            changeBetStatus(bet) {
                this.updateBets(this.bets);
            },
            fetchSystemCombination() {

                if (this.systemCombinations) {

                    this.possibleCombinations = [];
                    for (var c in this.systemCombinations) {

                        this.possibleCombinations[c.length] = (this.possibleCombinations[c.length] > 0) ? {
                            bets: Number(this.possibleCombinations[c.length].bets + c.length),
                            selected: 0
                        } : {bets: 1, selected: 0};

                    }
                }
            },
            setCustomAmount(a){
              this.amount = a
            },
            fetchSystemBets() {
                if (this.bets) {
                    var b;
                    this.systemBets = [];
                    this.bankers = [];
                    for (b in this.bets) {
                        if (this.bets[b].banker == false && this.bets[b].checked == true) {
                            this.systemBets.push(this.bets[b]);
                        } else if (this.bets[b].checked == true) {
                            this.bankers.push(this.bets[b]);
                        }
                    }
                }
            },
            resetOdd() {
                var odds = this.bets;

                for (var o in odds) {
                    var odd = odds[o];
                    odd.change = null
                }
            }
        },
        filters: {
            slimiter: function (str, limit) {
                return (str.length > limit) ? str.substring(0, limit) + '...' : str;
            },
        },
        closeOdd() {
            this.matchId = 0;
        },
        openMatch(m) {
            this.matchName = m.competitor.oneName + ' - ' + m.competitor.twoName
            this.matchId = m.matchId;
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


    .isBanker {
      width: 24px;
      height: 24px;
      flex-grow: 1;
      border-radius: 4px;
      background: var(--white);
      margin-right: 8px;
      cursor: pointer;
      border: 2px solid rgb(212, 212, 212);
      border-radius: 6px;
      text-align: center;
      color: rgb(156, 156, 156);
    }
    .BetslipStake-styles-max-stake-button, .isBanker.active {
      background: rgb(212, 212, 212);
      color: black;
    }

    .head i {
        font-size: 24px;
    }

    .bet-ou {
        position: relative;
        font-size: 12px;
    }

    .bet-ou:first-of-type {
        box-shadow: none !important
    }

    .cebg {
        top: -10px;
        position: absolute;
        width: 90%;
        height: 90%;
        opacity: 0.1;
        z-index: 1;
    }

    .oddType {
        position: relative;
        padding: 0px;
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 99px;
        margin-bottom: 15px;
        box-shadow: inset 0 1px 2px rgba(0, 0, 0, .12), inset 0 0 2px rgba(0, 0, 0, .15);
        background: #2CC185;
        color: #fff;
        margin: 5px 10px 5px 10px;
        padding: 5px 15px 5px 15px;
    }

    .oddType:after {
        content: '';
        position: absolute;
        border-style: solid;
        border-width: 10px 10px 0;
        border-color: #2CC185 transparent;
        display: block;
        width: 0;
        z-index: 1;
        margin-left: -10px;
        bottom: -9px;
        left: 10%;
    }

    .oddSelection {
        margin: 0 auto;
        border-collapse: separate;
        border: 1px solid #999;
        border-top: 0;
        width: 195px;
    }

    .oddSelection .content > div {
        display: flex;
    }

    .oddSelection .selected-odd {
        font-size: 11px;
        font-weight: bold;
        color: #000;
        line-height: 2;
        margin-left: 5px;
    }

    .oddSelection .oddSelection-check {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0;
        height: 21px;
        margin: 0 3px;
    }

    .oddSelection input[type="checkbox" i] {
        background: #ef8107;
    }

    .oddSelection .isBanker {
        padding: 2px 7px 2px 7px;
        margin: 6px 5px 5px -6px;
        border-radius: 5px;
        cursor: pointer;
        border: 1px solid #ff7f00;
        color: #ff7f00;
    }

    .oddSelection .isBanker.active {
        background: #ff7f00;
        color: #fff;
    }

    .oddSelection .outcome {
        width: 75%;
        padding: 3px 0 0 3px;
        font-size: 11px;
        text-align: left;
        color: #000;
        font-weight: 400;
        display: block;
    }

    .oddValue {
        padding: 0 5px 0 0;
        min-width: 42px;
        color: #000;
        line-height: 22px;
        text-align: right;
        position: absolute;
        width: 10%;
        right: 5px;
        font-size: 11px;
        font-weight: 400;
    }

    .betCount {
        font-size: 12px;
        font-weight: bold;
    }

    .clearBet {
        position: absolute;
        right: 5px;
        top: 3px;
        cursor: pointer;
        font-size: 15px;
        color: #ff007d;
    }

    .bet-error {
        color: var(--header-bg);
    }

    .tabs-style-topline nav a span {
        text-transform: capitalize;
        letter-spacing: 1px;
        font-weight: 400;
        font-size: 11px;
    }

    .tabs-style-topline nav li:hover {
        color: #ef8107 !important;
    }

    .possibleSystems ul {
        list-style: none;
        padding: 0;
        margin: 0;
        font-size: 14px;
    }

    .btn-bet {
        background: #3c3c3c;
        border: none;
        border-radius: 0;
        line-height: 2;
        text-align: center;
        width: 195px;
        margin: 5px auto;
    }

    .btn-bet a {
        color: #fff !important;
    }
    .btn-bet.maxStake{
        background: #f64835;
    }

    .possibleSystems ul li {
        /*margin-bottom: 5px;*/
        vertical-align: top;
        color: #fff;
        font-weight: lighter;
        background: white;
        /* border-radius: 3px; */
        border-bottom: 1px solid #dcdcdc !important;
        line-height: 28px;
        position: relative;
    }

    .possibleSystems ul i{
      top: 5px;
      left: 10px;
      font-size: 30px;
      position: absolute;
      color: rgb(212, 212, 212)
    }

    .possibleSystems ul li {
        padding: 5px 45px;
    }

    .possibleSystems ul li.head {
        display: none;
        font-weight: bold;
        border-bottom: 3px solid #2CC185;
    }

    .placeButton {
        margin: 0 0 5px;
        line-height: 48px;
        font-size: 24px;
        font-weight: bold;
        color: #555555;
        text-decoration: none;
        text-shadow: 0 1px white;
        background: #dfdfdf;
        border-width: 1px 1px 0;
        border-style: solid;
        border-color: #cecece #bababa #a8a8a8;
        border-radius: 3px 3px 2px 2px;
        outline: 0;
        display: inline-block;
        vertical-align: baseline;
        zoom: 1;
        -webkit-box-sizing: content-box;
        -moz-box-sizing: content-box;
        box-sizing: content-box;
        background-image: -webkit-linear-gradient(top, #f1f1f1, #dfdfdf 70%, #dadada);
        background-image: -moz-linear-gradient(top, #f1f1f1, #dfdfdf 70%, #dadada);
        background-image: -o-linear-gradient(top, #f1f1f1, #dfdfdf 70%, #dadada);
        background-image: linear-gradient(to bottom, #f1f1f1, #dfdfdf 70%, #dadada);
        -webkit-box-shadow: inset 0 1px #fdfdfd, inset 0 0 0 1px #eaeaea, 0 1px #a8a8a8, 0 3px #bbbbbb, 0 4px #a8a8a8, 0 5px 2px rgba(0, 0, 0, 0.25);
        box-shadow: inset 0 1px #fdfdfd, inset 0 0 0 1px #eaeaea, 0 1px #a8a8a8, 0 3px #bbbbbb, 0 4px #a8a8a8, 0 5px 2px rgba(0, 0, 0, 0.25);
    }

    .placeButton.fluid {
        width: 100%
    }

    .placeButton.green {
        color: #465f25;
        text-shadow: 0 1px #d9f3b5;
        background: #94d362;
        border-color: #91ce5e #7ab04b #5e903f;
        background-image: -webkit-linear-gradient(top, #c0eb85, #94d362 70%, #8ed258);
        background-image: -moz-linear-gradient(top, #c0eb85, #94d362 70%, #8ed258);
        background-image: -o-linear-gradient(top, #c0eb85, #94d362 70%, #8ed258);
        background-image: linear-gradient(to bottom, #c0eb85, #94d362 70%, #8ed258);
        -webkit-box-shadow: inset 0 1px #d9f3b5, inset 0 0 0 1px #b1e095, 0 1px #5e903f, 0 3px #6da445, 0 4px #5e903f, 0 5px 2px rgba(0, 0, 0, 0.4);
        box-shadow: inset 0 1px #d9f3b5, inset 0 0 0 1px #b1e095, 0 1px #5e903f, 0 3px #6da445, 0 4px #5e903f, 0 5px 2px rgba(0, 0, 0, 0.4);
    }

    .sumContainer {
        float: left;
        width: 100%;
        height: 300px;
        box-shadow: inset 0px 0px 21px 7px rgba(0, 0, 0, 0.1);
    }

    .betAmount {
        width: 50px;
        height: 13px;
        color: #000;
        border: 1px solid #666;
        padding-right: 1px;
        font-size: 11px;
        border-radius: 0;
        background: #fff;
        font-weight: 400;
        flex: 0;
        text-align: right;
    }

    .amount-block {
        font-weight: bold;
        /*background: none !important;
        padding: 10px 1px 10px 10px !important;*/

    }

    .amount-block .input-group {
        width: 50px;
        justify-content: right;
        display: block;
        float: right;
        margin: 3px 0;
        line-height: 1;
        font-size: 11px;
    }

    .wallet-block {
        font-weight: bold;
        background: #eee !important;
    }

    .wallet-type > .label {
        font-size: 14px;
    }

    .wallet-type {
        text-transform: uppercase;
        font-weight: bold;
        border: 2px solid #fff;
        cursor: pointer;
        padding: 4px;
        border-radius: 5px;
        margin: 2px;
        float: left;
        width: 99%;
    }

    .wallet-type:hover, .wallet-type.selected {

        color: blue;
        background: #fff;
    }

    .wallet-type.selected > .label {
        color: #fff !important;
    }

    .possibleSystems .pull-right {
        width: 50px;
        height: 13px;
        color: #000;
        text-align: right;
        border: 1px solid #666;
        padding-right: 1px;
        font-size: 11px;
        background: #fff;
        padding-left: 2px;
        line-height: 1;
    }

    .empty-coupon-text {
        font-size: 11px;
        margin: 5px 1px;
        color: #000;
        text-align: center;
    }

    .adviceBanner {
        width: 198px;
        height: 32px;
        background: #f64835;
        color: #FFF;
        position: relative;
        margin-bottom: 10px;
    }

    .adviceBanner:before {
        content: "";
        width: 198px;
        height: 12px;
        background: url(https://www.totobo1.com/img/adviceBanner_peak_bg-8EEB5711761E693E464A9C6DBA70D261.png) no-repeat;
        display: block;
        position: absolute;
        bottom: -10px;
    }

    .adviceBanner .wrap {
        width: 198px;
        height: 30px;
        background: #7c7c7c;
        color: #FFF;
        position: relative;
        margin-bottom: 10px;
    }

    .adviceBanner .deleteBtn {
        position: absolute;
        right: 4px;
        top: 2px;
        font-size: 14px;
        cursor: pointer;
    }

    .adviceText {
        text-align: center;
        padding: 4px 16px;
        line-height: 12px;
        font-size: 12px;
    }

    .adviceText span {
        color: #f64835;
        font-weight: bold;
    }
    .bet_slip_agreement {
        font-size: 11px;
        text-justify: center;
        padding: 3px 0;
    }
    .bet_slip_agreement input{
        float: left;
        margin-right: 5px;
    }

    .btn-bet a {
        display: block;
    }

    .bet_slip_agreement select{
        font-size: 11px;
        padding: 1px
    }

    .live-odd-value {
      padding: 2px 0 2px 26px !important;
      border-radius: 99px;
      background: url('/static/assets/img/Red_circle.gif') no-repeat;
      background-size: 15px;
      background-position: 3px;
      filter: grayscale(1);
    }

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/BetSlip.vue